/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refinetooldescription2Inputs */

const en_refinetooldescription2 = /** @type {(inputs: Refinetooldescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit an image with a text instruction using AI.`)
};

const de_refinetooldescription2 = /** @type {(inputs: Refinetooldescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bild per Texteingabe mit KI bearbeiten.`)
};

/**
* | output |
* | --- |
* | "Edit an image with a text instruction using AI." |
*
* @param {Refinetooldescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refinetooldescription2 = /** @type {((inputs?: Refinetooldescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refinetooldescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refinetooldescription2(inputs)
	return de_refinetooldescription2(inputs)
});
export { refinetooldescription2 as "refineToolDescription" }